(function (window) {
  /**
   * BatchGeoOmniboxClearSearchButton is a component that add an X inside the
   * omnibox input on the right and when a user types something it shows the
   * X. Clicking the X clears the search.
   *
   * @param {object} options An options hash
   * @param {BatchGeoOmniBox} options.omniboxInstance The instance of
   * BatchGeoOmnibox to pull the wrapper and input from.
   */
  var BatchGeoOmniboxClearSearchButton = function (options) {
    this.omniboxInstance = options.omniboxInstance;
    this._cacheElements();
    this.render();
    this._attachListeners();
  };

  /**
   * Helper function to just alias $omniboxInput and $omniboxWrapper. It also
   * makes sure the input is a jQuery object.
   *
   * @private
   */
  BatchGeoOmniboxClearSearchButton.prototype._cacheElements = function () {
    this.$omniboxInput = $(this.omniboxInstance.settings.omniboxInput);
    this.$omniboxWrapper = this.omniboxInstance.$omniboxWrapper;
  };

  /**
   * Renders the X button. It attaches a click handler to clear out the search
   * as well as hides/shows the initial rendered button based on if the input
   * was prefilled with anything on page load.
   */
  BatchGeoOmniboxClearSearchButton.prototype.render = function () {
    var self = this;
    this.$button = $("<button />", {
      addClass: "batchgeo-omnibox-clear-button",
      toggle: function () {
        return self.$omniboxInput.val();
      },
    }).appendTo(this.$omniboxWrapper);

    // It *must* be touchstart and click since iOS won't work with just
    // click based on our current UI. When you click it will unfocus the
    // input and then shrink it meaning a full click event will never happen
    // since a click is down+up on the same target. To mitigate, we pass in
    // touchstart which will trigger right when tapping.
    this.$button.on("touchstart click", function () {
      //when clicked reset the searchLocation state to reset map list
      BatchGeoStore.dispatch({
        type: "STORE_UPDATE_SEARCH_LOCATION",
        searchLocation: null,
      });
      self.$omniboxInput.val("");

      //need to clear the search marker if its present
      if (window.per.searchMarker) {
        let mrk = window.per.searchMarker;

        // remove map reference
        mrk.setMap(null);

        // remove marker reference
        window.per.searchMarker = null;
      }

      self.$button.toggle(false);
    });
  };

  /**
   * Listen for change events which happen when the user blurs out OR more
   * importantly for our use case, when JS changes the input content. This
   * will happen when a user clicks the clear search button. We also use keyup
   * here and not keypress or down because keyup will return the current value
   * of the input. Keypress/down will return the last value.
   */
  BatchGeoOmniboxClearSearchButton.prototype._attachListeners = function () {
    var self = this;

    this.$omniboxInput.on("change keyup", function () {
      self.$button.toggle(!!self.$omniboxInput.val());
    });
  };

  window.BatchGeoOmniboxClearSearchButton = BatchGeoOmniboxClearSearchButton;
})(window);
